// generated from 2_079_156 samples

import { z } from "zod";
import { stepGetBaseSchema } from "./stepGetBaseSchema";

export const messageStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("MESSAGE"),
  step_data: z.never().optional(),
});
